import React from "react";
import styled from "styled-components";
import PageHeader from "../../Elements/Header";
import blogsData from "../Data/Blog";
const BlogPageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
  display: flex;
  gap: 2rem;

  @media (max-width: 768px) {
    flex-direction: column; /* Stack columns vertically */
  }
`;

const LeftColumn = styled.div`
  flex: 2;
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Two columns */
  gap: 2rem; /* Space between cards */

  @media (max-width: 768px) {
    grid-template-columns: 1fr; /* Single column on smaller screens */
  }
`;

const RightColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media (max-width: 768px) {
    flex: none; /* Adjust flex behavior */
  }
`;

const SearchBar = styled.div`
  background: #ffffff;
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  input {
    width: 100%;
    padding: 0.75rem;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 5px;

    &:focus {
      outline: none;
      border-color: #3182ce;
    }
  }
`;

const Categories = styled.div`
  background: #ffffff;
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  h3 {
    font-size: 1.25rem;
    color: #2d3748;
    margin-bottom: 1rem;
  }

  ul {
    list-style: none;
    padding: 0;

    li {
      margin-bottom: 0.5rem;

      a {
        text-decoration: none;
        color: #3182ce;
        font-weight: 500;

        &:hover {
          color: #2c5282;
        }
      }
    }
  }

  @media (max-width: 768px) {
    h3 {
      font-size: 1rem; /* Adjust heading size */
    }

    ul li {
      margin-bottom: 0.25rem; /* Adjust spacing */
    }
  }
`;

const BlogCard = styled.div`
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  img {
    width: 100%;
    height: 200px;
    object-fit: cover;
  }

  .content {
    padding: 1rem;

    .date-badge {
      background-color: #3182ce;
      color: #ffffff;
      font-size: 0.9rem;
      font-weight: bold;
      padding: 0.5rem 1rem;
      display: inline-block;
      border-radius: 5px;
      margin-bottom: 0.5rem;
    }

    h3 {
      font-size: 1.25rem;
      color: #2d3748;
      margin-bottom: 0.5rem;
    }

    p {
      font-size: 0.9rem;
      color: #4a5568;
      margin-bottom: 1rem;
    }

    a {
      text-decoration: none;
      color: #3182ce;
      font-weight: bold;

      &:hover {
        color: #2c5282;
      }
    }
  }
`;

export default function BlogPage() {
  return (
    <>
    <>
  <PageHeader
    title="Our Blog"
   subtitle="Latest Insights"
    description="Stay informed with the latest articles, tips, and insights from Pristine Academic Consultancy. Explore a variety of topics to help you succeed academically."
    buttonText="Read Our Latest Post"
    buttonAction={() => alert('Latest post button clicked!')}
    backgroundImage="images/Woman1.jpg" // Replace with an actual background image
  />
</>

    <BlogPageContainer>
      <LeftColumn>
        {blogsData.mostRecent.map((blog, index) => (
          <BlogCard key={index}>
            <img src={blog.image} alt={blog.title} />
            <div className="content">
              <div className="date-badge">{blog.date}</div>
              <h3>{blog.title}</h3>
              <p>{blog.description}</p>
              <a href={blog.link}>Read More</a>
            </div>
          </BlogCard>
        ))}
      </LeftColumn>
      <RightColumn>
        <SearchBar>
          <input type="text" placeholder="Search Here..." />
        </SearchBar>
        <Categories>
          <h3>Blog Categories</h3>
          <ul>
            {blogsData.categories.map((category, index) => (
              <li key={index}>
                <a href={category.link}>{category.name}</a>
              </li>
            ))}
          </ul>
        </Categories>
      </RightColumn>
    </BlogPageContainer>
    </>
  );
}
